class FavouriteStoreController {
    /*@ngInject*/
    constructor($log, $http, $rootScope, CommonService) {
        $log.debug('FavouriteStoreController initialized');
        this.$log                = $log;
        this.$http               = $http;
        this.$rootScope          = $rootScope;
        this.commonService       = CommonService;
        this.favouritePos        = false;
        this.isFavStoreAvailable = false;
        this.favButtonChecked    = false;

        this.$rootScope.$on('personalizeRequestSuccess', () => {
            this.favouritePos = this.commonService.getPersonalizeRequestResponse().favouritePOS;
            if (this.favouritePos !== undefined && this.favouritePos !== null && this.favouritePos !== "") {
                this.isFavStoreAvailable = true;
            }
        });

        this.$rootScope.$on('favouriteStoreFilterBoxRendered', () => {

            if ($("#favourite-store-button").length === 0) {
                //no fav button on the current page
                return;
            }

            let currentScope = window.angular.element('#algolia-rendered-filters').scope().favouriteStore;
            //if the button is rendered but the stores filter is not (due to other filter) remove the button
            var favShopFilterCheckbox = $(".search-filter-availableStoresList").find(`input[value="${currentScope.favouritePos}"]`);
            //in some cases, the section is present in dom, but the child element is hidden -> essentially removed
            var hiddenChild = $(".search-filter-availableStoresList").find(".algolia-filter-panel").attr('hidden');
            if(favShopFilterCheckbox === undefined || favShopFilterCheckbox.length === 0 || (hiddenChild !== undefined && hiddenChild.length > 0)){
                currentScope.removeFavSection();
                return;
            }

            //in case the filter checkbox changes, the page is re-rendered
            //this snippet synchronize the button state when
            //checkbox check/uncheck and the filter bar changes as well
            if (currentScope.getFavStoreAlgoliaFilterSelected() === true) {
                $("#favourite-store-button").prop('checked', true)
                currentScope.favButtonChecked = true;
            } else {
                $("#favourite-store-button").prop('checked', false)
                currentScope.favButtonChecked = false;
            }
        });

        this.$rootScope.$on('favouriteStoreButtonRendered', () => {
            let favButton          = $("#favourite-store-button");
            let storeFilterSection = $(".search-filter-availableStoresList");
            let currentScope       = window.angular.element('#algolia-rendered-filters').scope().favouriteStore;

            if (favButton.length === 0) {
                //Button was removed already
                return;
            }

            if (currentScope.isFavStoreAvailable === false) {
                currentScope.removeFavSection();
                return;
            }

            var favShopFilterCheckbox = storeFilterSection.find(`input[value="${currentScope.favouritePos}"]`);
            if (storeFilterSection.length > 0) {
                if (favShopFilterCheckbox.length === 0) {
                    //No product in the favourite shop
                    currentScope.removeFavSection();
                    return;
                }
                //set the store id, because the event handler is outside angular scope
                favButton.data("fav", currentScope.favouritePos);
            } else {
                //stores list not rendered at all
                currentScope.removeFavSection();
                return;
            }

            if (favButton.data('init') === true) {
                if (currentScope.getFavStoreAlgoliaFilterSelected() === true) {
                    $("#favourite-store-button").prop('checked', true)
                    this.favButtonChecked = true;
                } else {
                    $("#favourite-store-button").prop('checked', false)
                    this.favButtonChecked = false;
                }
                currentScope.bindEventListener(favButton);
                favButton.removeData('init');
                favButton.removeAttr('data-init');
            }

        });

        this.removeFavSection = function () {
            var favButton = $("#favourite-store-button");
            if (favButton.length > 0) {
                favButton.closest('.search-filter-panel').remove();
            }
        }

        this.bindEventListener = function (favButton) {
            favButton.change(function () {
                let favouritePos = $("#favourite-store-button").data('fav')
                if (favouritePos !== undefined) {
                    let currentScope = window.angular.element('#algolia-rendered-filters').scope().favouriteStore;

                    if (currentScope.favButtonChecked === true) {
                        currentScope.favButtonChecked = false;
                        if (currentScope.getFavStoreAlgoliaFilterSelected() !== true) {
                            //if the filter was removed in the meantime no need to search again
                            return;
                        }
                    } else {
                        currentScope.favButtonChecked = true;
                        if (currentScope.getFavStoreAlgoliaFilterSelected() === true) {
                            //if the filter is already selected in the meantime no need to search again
                            return;
                        }
                    }

                    //"valid" case, toggle the refinementList
                    if (window.instantSearch !== undefined) {
                        window.instantSearch.helper.toggleRefinement('availableStoresList', favouritePos);
                        window.instantSearch.helper.search();
                    }
                }
            });
        }

        this.getFavStoreAlgoliaFilterSelected = function () {
            let favouritePos = $("#favourite-store-button").data('fav');
            return $(".search-filter-availableStoresList").find(`input[value="${favouritePos}"]`).closest(
                    '.ais-RefinementList-item').hasClass("ais-RefinementList-item--selected") === true;
        }
    }
}

export default FavouriteStoreController;